// constants
import { showSuccessAlert } from "../../constants/alerts";
import { BannerActionTypes } from "./constants";

const INIT_STATE = {
  banners: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface bannerData {
  id: number;
  image: File | null;
}

interface BannerActionType {
  type:
    | BannerActionTypes.API_RESPONSE_SUCCESS
    | BannerActionTypes.API_RESPONSE_ERROR
    | BannerActionTypes.CREATE_BANNER
    | BannerActionTypes.UPDATE_BANNER
    | BannerActionTypes.GET_BANNER
    | BannerActionTypes.DELETE_BANNER_IMAGE
    | BannerActionTypes.DELETE_BANNER;
  payload: {
    actionType?: string;
    data?: bannerData | {};
    error?: string;
    banners?: [];
  };
}

interface State {
  banners?: bannerData[] | [];
  loading?: boolean;
  value?: boolean;
}

const BannerStates = (
  state: State = INIT_STATE,
  action: BannerActionType
): any => {
  switch (action.type) {
    case BannerActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case BannerActionTypes.CREATE_BANNER: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case BannerActionTypes.GET_BANNER: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            banners: action.payload.data,
          };
        }
        case BannerActionTypes.UPDATE_BANNER: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case BannerActionTypes.DELETE_BANNER: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case BannerActionTypes.DELETE_BANNER_IMAGE: {
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case BannerActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case BannerActionTypes.CREATE_BANNER: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case BannerActionTypes.UPDATE_BANNER: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        }
        case BannerActionTypes.GET_BANNER: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case BannerActionTypes.DELETE_BANNER: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case BannerActionTypes.DELETE_BANNER_IMAGE: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case BannerActionTypes.CREATE_BANNER:
      return { ...state, loading: true };
    case BannerActionTypes.UPDATE_BANNER:
      return { ...state, loading: true };
    case BannerActionTypes.GET_BANNER:
      return { ...state, loading: true, initialLoading: true };
    case BannerActionTypes.DELETE_BANNER:
      return { ...state, loading: true };
    case BannerActionTypes.DELETE_BANNER_IMAGE:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default BannerStates;
